import React from 'react';
import './App.css';
import Main from './ui/main.js';


function App() {
  return (
    <div className="App">
     <Main/>     
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js